module.exports = {
	common: require("./common.json"),
};
